/**
 * 로그인을 요청한다. `POST /app/auths`.
 *
 * 로그인 화면(`pages/login.tsx`)에서 쓴다. 아직 인증 전이라 `axiosPublic` 을 쓴다.
 *
 * 주의: 이 파일은 `pages/api/` 안에 있지만 서버에서 도는 코드가 아니다.
 */
import publicApi from "pages/api/axiosPublic";

interface AuthUserResponse {
  isSuccess: boolean;
  code: number;
  message: string;
  result: {
    userId: number;
    accessToken: string;
    /** 사용자 역할. 로그인 시 sessionStorage `role` 키에 저장하고 분기 라우팅에 사용한다. */
    role: "STUDENT" | "TEACHER";
    /**
     * 초기 비밀번호 강제 변경 필요 여부. 관리자가 계정을 일괄 생성/일괄 변경하면 켜지고,
     * 학생이 스스로 비밀번호를 바꾸면 꺼진다. 로그인 시 sessionStorage `needPasswordChange`
     * 키에 문자열("true"/"false")로 저장하고, true 면 `/password-setup` 으로 보낸다.
     */
    needPasswordChange: boolean;
    /** 사용자 이름. 로그인 시 sessionStorage `userName` 에 저장해 비밀번호 설정 화면 환영 메시지에 쓴다. 과거 서버는 주지 않는다. */
    name?: string | null;
  };
}

/**
 * @returns 성공하면 `accessToken`/`userId`/`role`/`needPasswordChange` 를 담은 응답. 서버가 오류 응답(4xx 등)을 줘도
 *   그 본문을 그대로 반환해 화면에서 실패 사유를 보여줄 수 있게 한다.
 *   요청 자체가 실패하면(네트워크 오류 등) null.
 */
export const authUser = async (
  id: string,
  pw: string
): Promise<AuthUserResponse | null> => {
  try {
    const response = await publicApi.post<AuthUserResponse>("/app/auths", {
      email: id,
      password: pw,
    });

    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    console.error("Axios 요청 실패:", error);
    return null;
  }
};

export default authUser;
